import { Container, createStyles, makeStyles, Typography } from "@material-ui/core"
import React from "react"


type Props = {

}

export const FlutterWhat = (props: Props) => {
    const classes = useStyles({});
    return <>
        <div className={classes.section}>
            <Container maxWidth='md'>
                <Typography align='center' gutterBottom variant='h3'>What We Do?</Typography>
                <Typography gutterBottom variant='h4' align='center'>We create meaningful connections authentically by focusing on your personality and not
            superficial metrics.</Typography>
            
            <Typography align='center' variant='h6'>P.s. If you are not looking for a real connection, use one of the "Swiping" apps instead.</Typography>
            </Container>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className={classes.wave}>
        <path fill="#f04b4c" fillOpacity="1" d="M0,64L60,85.3C120,107,240,149,360,176C480,203,600,213,720,197.3C840,181,960,139,1080,117.3C1200,96,1320,96,1380,96L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
        </svg>
    </>
}

const useStyles = makeStyles(theme => createStyles({
    section: {
        paddingTop: theme.spacing(10),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        background: theme.palette.primary.main,
        color: 'white',
    },
    wave: {
        display: 'block',
    }
}))